import { Link } from 'react-router-dom';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function WhyUsCTABand() {
  const { ref, revealed } = useScrollReveal();

  return (
    <section className="py-16 md:py-20 bg-gradient-to-r from-brand-700 via-brand-600 to-secondary-700">
      <div
        className="absolute inset-0 opacity-[0.02]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='80' height='80' viewBox='0 0 80 80' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Ccircle cx='40' cy='40' r='1.5'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}
      ></div>
      <div ref={ref} className={`container-page relative z-10 scroll-reveal ${revealed ? 'revealed' : ''}`}>
        <div className="text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-paper-50 mb-4">
            See the Difference Yourself
          </h2>
          <p className="text-brand-100/80 max-w-xl mx-auto mb-8 text-sm md:text-base">
            Whether you&apos;re a warehouse owner, transporter, buyer, or consumer — Freshhlock changes how India&apos;s frozen food moves.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/contact"
              className="px-8 py-3.5 bg-accent-500 hover:bg-accent-400 text-brand-800 font-semibold text-sm rounded-lg transition-all whitespace-nowrap cursor-pointer"
            >
              Partner With Freshhlock
            </Link>
            <Link
              to="/contact"
              className="px-8 py-3.5 border border-paper-50/40 hover:border-paper-50/80 text-paper-50 font-medium text-sm rounded-lg transition-all whitespace-nowrap cursor-pointer"
            >
              Talk to Our Team
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}